import { getMailboxFolderTreeData } from './getMailboxFolderTreeDataTable';
import type { MailboxInfo } from 'owa-client-types';

/**
 * Selector for a particular mailbox shared resource archive information
 * @param sharedFolderUserEmail identifies the shared resource tree uniquely
 * @param mailboxInfo identifies which primary mailbox the shared item is associated with, used to retrieve the folder tree data
 */
export default function getSharedFolderArchiveMailboxInfo(
    mailboxInfo: MailboxInfo
): MailboxInfo | undefined {
    const mailboxFolderTreeDataTable = getMailboxFolderTreeData(mailboxInfo);
    const archiveData = mailboxFolderTreeDataTable?.sharedArchiveInformation.get(
        mailboxInfo.mailboxSmtpAddress
    );
    return archiveData;
}
